<template>
    <div :class="[
        'program-live-status--label',
        `live-status--${liveStatus}`,
    ]">
        <span v-if="liveStatus === 'live'">{{ $t('words.program_live_status_live') }}</span>
        <span v-else-if="liveStatus === 'end'">{{ $t('words.program_live_status_end') }}</span>
    </div>
</template>

<script>
export default {
    name: 'ProgramLiveStatus',
    props: {
        liveStatus: {
            type: String,
            default: 'none',
        },
    },
};
</script>
